module.exports = __webpack_public_path__ + "img/i_o_my_qa.47b62642.svg";